import { useMutation, useQueryClient } from "@tanstack/react-query";

import Axios from "@/lib/axios-instance";

interface ResolveTicketPayload {
    status: string;
}

export const resolveTicket = async (id: number, payload: ResolveTicketPayload = { status: "resolved" }) => {
    try {
        const response = await Axios.patch(`/tickets/${id}/resolve`, payload);
        return response.data;
    } catch (error: any) {
        if (error.response) {
            throw new Error(`${error.response.data?.meta?.message || "An error occurred"}`);
        }
        throw new Error(error.message || "Network Error");
    }
};

export const useResolveTicket = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (params: { id: number; payload?: ResolveTicketPayload }) => resolveTicket(params.id, params.payload),
        onSuccess: (_, variables) => {
            // Invalidate and refetch tickets query to update the list
            queryClient.invalidateQueries({ queryKey: ["get-tickets"] });
            // Invalidate and refetch the specific ticket detail query
            queryClient.invalidateQueries({ queryKey: ["get-ticket-detail", variables.id] });
        },
    });
};